<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { navMessages } from "./i18n/nav";
import NavLink from "./NavLink.vue";

/**
 * O PÉ DA COLUNA: uma linha só, e sempre a mesma.
 *
 * Configurações não é um assunto entre os assuntos — é o lugar para onde se vai
 * quando o painel já não faz o que se queria. Dentro do grupo "Workspace" ela
 * descia junto com ele e sumia quando alguém o fechava; aqui ela está fora do
 * scroll, colada embaixo, separada por um traço. É onde a V2 a põe, e é onde a
 * mão desce sem ler.
 *
 * Fora do `<nav>` que rola, e por isso um bloco próprio: uma engrenagem que
 * flutua sobre uma lista de vinte linhas é a única coisa que não pode depender
 * de onde a lista parou.
 *
 * Reusa o `NavLink`. Um botão paralelo com a mesma cara seria a segunda
 * definição de "linha do menu" — e é sempre a segunda que diverge.
 */
defineProps<{ narrow?: boolean }>();

const emit = defineEmits<{ navigate: [] }>();

const { t } = useI18n({ useScope: "local", inheritLocale: true, messages: navMessages });
</script>

<template>
	<div class="shrink-0" :class="narrow ? 'px-1.5 py-2' : 'px-2.5 py-3'">
		<NavLink
			:row="{ to: '/settings', label: t('items.settings.label'), icon: 'settings' }"
			:narrow="narrow"
			@navigate="emit('navigate')"
		/>
	</div>
</template>
